var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3 text-center",staticStyle:{"width":"100%"}},[_c('img',{attrs:{"src":require("../assets/images/logo.svg"),"alt":"vaporfly logo","height":_vm.imgHeight,"width":_vm.imgHeight * _vm.aspectRatio}})])}
var staticRenderFns = []

export { render, staticRenderFns }